import { useSelector } from 'react-redux';
import { getLabelFallback, roundNumber } from '@utils/utils';
import { useState } from 'react';
import SlimArrow from '@images/svg-icons/slim-arrow.svg';

const StoreDetails = props => {
  const selectedStore = useSelector((state) => state.cart.selectedStore);

  const [showStoreHours, setShowStoreHours] = useState(true);

  const getDirections = () => {
    var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=';

    if (selectedStore) {
      directionsUrl += encodeURIComponent(
        selectedStore.addressLine[0].trim() +
          ',' +
          selectedStore.city.trim() +
          ',' +
          selectedStore.stateOrProvinceName.trim() +
          ',' +
          selectedStore.postalCode.trim()
      );

      window.open(directionsUrl, '_blank');
    }
  };

  const StoreAddress = props => {
    if (props.show) {
      return (
        <div className="container-fluid-boss">
          <div className="row">
            <div className="store-name-container">
              <span className="store-name">
                {selectedStore.Description[0].displayStoreName.toLowerCase().replace('lenscrafters', 'LensCrafters')}{' '}
              </span>
            </div>
          </div>
          <div className="row m-bottom">
            <div className="container-row store-address-container">
              <span className="store-address">
                {selectedStore.addressLine[0].toLowerCase()} {selectedStore.city.toLowerCase()},{' '}{selectedStore.stateOrProvinceName}
              </span>
              <div className="store-miles-container">
                <span className="store-miles">
                    {roundNumber(selectedStore.distance) + getLabelFallback('CURRENCY_DISTANCE_LABEL')}
                </span>
                </div>
            </div>
          </div>
          <div className="row">
            <div className="container-middle align-left store-phone-number-container">
              <StorePhoneNumber show={selectedStore}></StorePhoneNumber>
            </div>
            <div className="container-middle align-right">
              <div className="get-directions-container" onClick={getDirections}>
                <a href="#" className="get-directions violet-button-negative" data-element-id="OEE_StoreGetDirections">
                  {getLabelFallback('GET_DIRECTIONS_LABEL')}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const StoreHours = props => {
    if (props.show) {
      return (
        <div className="container-fluid-boss">
          <div className="row">
            <div
              className="container-row see-hours"
              onClick={() => setShowStoreHours(!showStoreHours)}
            >
              <span className="store-hours" onClick={() => {
                window?.tealium_data2track?.push({
                  id: 'Click',
                  data_element_id: 'X_X_FindStoreOverlay_OpeningHours'
                })
              }}>{getLabelFallback('SEE_HOURS_LABEL')}</span>
              {showStoreHours ? (
                <SlimArrow
                  className="arrow-up"
                  data-element-id="X_Pdp_FindStoreOverlay_OpeningHours"
                />
              ) : (
                <SlimArrow
                  className="arrow-down"
                  data-element-id="X_Pdp_FindStoreOverlay_OpeningHours"
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="container-row opening-hours">
              {showStoreHours && <GetStoreOpeningHours></GetStoreOpeningHours>}
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const GetStoreOpeningHours = () => {
    const storeAttributes = selectedStore.Attribute;
    let values;
    storeAttributes.forEach(element => {
      if (element.displayName === 'StoreHours') {
        values = element.displayValue.split(';');
      }
    });
    // filter store hours to show one value for week days
    const storeHours = values.map((item, index) => (
      <div key={index} className="row row-open-hours">
        <div className="store-opening-hours-day M-top M-bottom">
          {' '}
          {getLabelFallback('WEEKDAY' + index)}
        </div>
        <div className="store-opening-hours">{item}</div>
      </div>
    ));
    return storeHours;
  };

  const StorePhoneNumber = props => {
    if (props.show) {
      return (
        <div className="container-fluid-boss">
          <div className="row">
            <div className="container-row telephone-number-container">
              <a
                className="telephone-number"
                rel="noreferrer"
                href={'tel:' + selectedStore.telephone1}
                target="_blank"
                data-element-id="OEE_StorePhoneNum"
              >
                {selectedStore.telephone1}
              </a>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container-fluid-boss">
      <div className="row">
        <div className="container-row">
          <StoreAddress show={selectedStore}></StoreAddress>
        </div>
      </div>
      <div className="row">
        <div className="container-row">
          <div hidden={!selectedStore} className="separator-line"></div>
        </div>
      </div>
      <div className="row">
        <div className="container-row">
          <StoreHours show={selectedStore}></StoreHours>
        </div>
      </div>
    </div>
  );
};

export default StoreDetails;
